'use strict';
var novicell = novicell || {};

novicell.lazyLoader = novicell.lazyLoader || function () {

	function init(wrapper) {
		lazy_load(wrapper);
	}

	function lazy_load(wrapper) {
		let parent 		= wrapper ? wrapper : document,
			lazyImages 	= [].slice.call(parent.querySelectorAll('.js-lazy-load')),
			inAdvance 	= 100;

		// Check if browser supports IntersectionObserver
		if ("IntersectionObserver" in window) {

			let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
				entries.forEach(function(entry) {
					if (entry.isIntersecting) {
						let lazyImage = entry.target,
							element_img = lazyImage.getElementsByTagName('img')[0];

						element_img.src = element_img.dataset.src;
						element_img.srcset = element_img.dataset.srcset;

						element_img.onload = function() {
							lazyImage.classList.add('img-loaded');

							// Remove lazy-load class after load, so the watcher doesnt listen for them
							setTimeout(function() {
								lazyImage.classList.remove('js-lazy-load');
							}, 1000);
						};

						element_img.error = function() {
							console.log('Error loading image: ' + element_img.src);
						};

						lazyImageObserver.unobserve(lazyImage);
					}
				});
			}, {
				// Load image when 100px above bo
				rootMargin: '0px 0px ' + inAdvance + 'px 0px'
			});

			lazyImages.forEach(function(lazyImage) {
				lazyImageObserver.observe(lazyImage);
			});

		// Fallback if browser doesn't support IntersectionObserver
		} else {

			let active 		= false;

			const lazyLoad = function() {
				if (active === false) {
					active = true;

					setTimeout(function() {
						lazyImages.forEach(function(lazyImage) {
							let element_img = lazyImage.getElementsByTagName('img')[0];

							if ((lazyImage.getBoundingClientRect().top <= window.innerHeight + inAdvance && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {

								element_img.src = element_img.dataset.src;
								element_img.srcset = element_img.dataset.srcset;

								element_img.onload = function() {
									lazyImage.classList.add('img-loaded');

									// Remove lazy-load class after load, so the watcher doesnt listen for them
									setTimeout(function() {
										lazyImage.classList.remove('js-lazy-load');
									}, 1000);
								};

								element_img.error = function() {
									console.log('Error loading image: ' + element_img.src);
								};

								lazyImages = lazyImages.filter(function(image) {
									return image !== lazyImage;
								});

								if (lazyImages.length === 0) {
									document.removeEventListener('scroll', lazyLoad);
									window.removeEventListener('resize', lazyLoad);
									window.removeEventListener('orientationchange', lazyLoad);
								}
							}
						});

						active = false;
					}, 200);
				}
			};

			lazyLoad();
			document.addEventListener('scroll', lazyLoad);
			window.addEventListener('resize', lazyLoad);
			window.addEventListener('orientationchange', lazyLoad);

		}
	}

	return {
		init : init,
		lazy_load : lazy_load
	};

}();